import React from 'react';
import { Badge, ButtonGroup, Col, Row, ToggleButton } from 'react-bootstrap';
import tickBlack from '../../assets/svg/Tick-black.svg';
import { Controller, useFormContext } from 'react-hook-form';
import { CheckinForm, CheckinFormNames } from '../../service/checkin-flow';

type ICheckboxInlineProps = {
    name: CheckinFormNames,
    label: string
}

export const CheckboxInline = ({ name, label }: ICheckboxInlineProps) => {
    const { control } = useFormContext<CheckinForm>();

    return (
        <Row>
            <Col className='text-center'>
                <ButtonGroup toggle className='mb-2 no-outline'>
                    <Controller control={control} name={name} defaultValue={true} render={({ onChange, onBlur, value }) => (
                        <ToggleButton type='checkbox'
                                      variant=''
                                      checked={value}
                                      value={1}
                                      onChange={e => onChange(e.target.checked)}
                                      onBlur={onBlur}>
                            <Badge pill
                                   variant={value ? 'success' : 'secondary'}
                                   className={(value ? 'checkbox-checked' : 'checkbox-unchecked') + ' p-1 my-auto'}>
                                <img alt='' src={tickBlack} className='checkbox-img' />
                            </Badge>
                            <span className='body-text pl-1 checkbox-label text-not-dim'><small>{label}</small></span>
                        </ToggleButton>
                    )} />
                </ButtonGroup>
            </Col>
        </Row>
    );
};
